import { AUTH_CONFIG_IDS } from './auth.config';

// angular-auth-oidc-client does not emit when it silently renews the access token: the session it stores is the
// only place where the current token can be read.
export function getInstallerAccessToken(): string {
    const storedSession = localStorage.getItem(AUTH_CONFIG_IDS.INSTALLER);
    if (!storedSession) {
        return '';
    }

    const session = JSON.parse(storedSession) as { authnResult: { access_token: string } };
    return session.authnResult.access_token;
}
